import React from 'react'
import styled from 'styled-components'
import { v1 as color, media } from 'sidecar-design-library'

import BaseIcon from '../IconV1'

export const Wrapper = styled.div`
  line-height: 1.0625rem;
  align-items: center;
  margin-top: 0.625rem;

  // Allows rating and stars to be inline by default
  display: flex;

  ${media.laptopAndBelow`
    flex-wrap: wrap;
    ${'' /* only want a gap if there's a rating before it */}
    gap: ${({ reviewCount }) => (reviewCount > 0 ? '0.625rem' : '0')};
  `}

  &:not(:last-child) {
    margin-bottom: 0.125rem;
  }
`

export const StarRatingWrapper = styled.div`
  display: flex;
  margin: -0.0625rem 0;
`

export const Stars = styled.span`
  height: 1.25rem;
`

export const Star = styled(({ isActive, ...rest }) => (
  <BaseIcon {...rest} />
)).attrs({
  name: 'star',
})`
  margin: 0 0.125rem 0 0;
  font-size: 1.0625rem;
  vertical-align: middle;
  color: ${color.AQUA_OVERLAY};

  ${p =>
    p.isActive &&
    `
    color: ${color.SCOOTER};
  `}
`

export const Reviews = styled.div`
  font-size: 1.0625rem;
  line-height: 1.25rem;
  margin-left: 0.3125rem;
  margin-right: 0.9375rem;
  color: ${color.GREY};

  // nowrap prevents "0 Reviews" from splitting
  white-space: nowrap;
`

export const Label = styled.div`
  margin-left: 0.3125rem;
  font-size: 0.9375rem;
  color: ${color.MORTAR};
`
